module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "健康证明"
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.formData.jiankangpics,
      "accept": ".pdf",
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传健康证明")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "保险投保单"
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.formData.baodanpics,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传保险投保单")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "自愿参赛责任书"
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.formData.zerenshupics,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传自愿参赛责任书")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确定提交\n          ")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92015128","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/SaiApplyFile.vue
// module id = 1505
// module chunks = 0